<template>
  <div class="columns is-desktop">
    <div class="column">
      <config-integration-submission-specifications
        v-if="!personTypeDetails && !specificationsDetails"
        @attachAllPersonTypes = "setAllPersonTypes($event)"
        @showPersonTypeDetails = "togglePersonTypeDetails(); setPersonType($event)"
        @showSpecificationsDetails = "toggleSpecificationsDetails(); setSpecificationType($event)"
        style="margin-bottom: 1rem"
      />
      <config-integration-person-type-details
        v-else-if="personTypeDetails"
        @showSubmissionSpecifications = "togglePersonTypeDetails"
        :receivedPersonType="holdPersonTypeData"
        :receivedAllPersonTypes="allPersonTypes"
      />
      <config-integration-specifications-details
        v-else-if="specificationsDetails"
        @showSubmissionSpecifications = "toggleSpecificationsDetails"
        :receivedSpecificationType="holdSpecificationType"
      />
      <config-integration-sources
        v-if="!personTypeDetails && !specificationsDetails"
      />
    </div>
    <div class="column is-one-quarter">
      <config-integration-security-properties
        v-if="!personTypeDetails && !specificationsDetails"
        style="margin-bottom: 1rem"
      />
      <config-integration-automatic-file-processing
        v-if="!personTypeDetails && !specificationsDetails"
        style="margin-bottom: 1rem"
      />
      <quick-tips-integration
        v-if="personTypeDetails"
        style="margin-bottom: 1rem"
      />
      <quick-tips-integration-specification
        v-if="specificationsDetails"
        style="margin-bottom: 1rem"
      />
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEdit,
} from '@fortawesome/pro-solid-svg-icons';
import ConfigIntegrationSubmissionSpecifications from '@/components/ConfigIntegrationSubmissionSpecifications.vue';
import ConfigIntegrationPersonTypeDetails from '@/components/ConfigIntegrationPersonTypeDetails.vue';
import ConfigIntegrationSpecificationsDetails from '@/components/ConfigIntegrationSpecificationsDetails.vue';
import ConfigIntegrationSecurityProperties from '@/components/ConfigIntegrationSecurityProperties.vue';
import ConfigIntegrationAutomaticFileProcessing from '@/components/ConfigIntegrationAutomaticFileProcessing.vue';
import ConfigIntegrationSources from '@/components/ConfigIntegrationSources.vue';
import QuickTipsIntegration from '@/components/QuickTipsIntegration.vue';
import QuickTipsIntegrationSpecification from '@/components/QuickTipsIntegrationSpecification.vue';

library.add(
  faEdit,
);
export default {
  data() {
    return {
      allPersonTypes: [],
      holdPersonTypeData: [],
      holdSpecificationType: null,
      personTypeDetails: false,
      specificationsDetails: false,
    };
  },
  components: {
    ConfigIntegrationSubmissionSpecifications,
    ConfigIntegrationPersonTypeDetails,
    ConfigIntegrationSpecificationsDetails,
    ConfigIntegrationSecurityProperties,
    ConfigIntegrationAutomaticFileProcessing,
    ConfigIntegrationSources,
    QuickTipsIntegration,
    QuickTipsIntegrationSpecification,
  },
  methods: {
    setAllPersonTypes(personTypes) {
      this.allPersonTypes = personTypes;
      return this.allPersonTypes;
    },
    setPersonType(receivedPersonTypeData) {
      this.holdPersonTypeData = receivedPersonTypeData;
      return this.holdPersonTypeData;
    },
    setSpecificationType(receivedSpecificationType) {
      this.holdSpecificationType = receivedSpecificationType;
      return this.holdSpecificationType;
    },
    togglePersonTypeDetails() {
      this.personTypeDetails = !this.personTypeDetails;
    },
    toggleSpecificationsDetails() {
      this.specificationsDetails = !this.specificationsDetails;
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
</style>
